"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _tabbable = _interopRequireDefault(require("./tabbable"));
var _executionEnvironment = require("./execution-environment");
/*
 * Adapted from Design System React
 */

// Used to find all tabbable elements within the ancestor element.

// Checks if the DOM is available in the current environment.

var ancestor = null;
var focusLaterElement = null;
var handleScopedKeyDown = function handleScopedKeyDown(event) {
  if (!_executionEnvironment.canUseDOM || !ancestor || event.keyCode !== 9) {
    return;
  }
  var tabbableElements = (0, _tabbable["default"])(ancestor);
  var finalTabbable = tabbableElements[event.shiftKey ? 0 : tabbableElements.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  ancestor === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbableElements[event.shiftKey ? tabbableElements.length - 1 : 0];
  target.focus();
};

// PUBLIC methods
var ElementFocus = {
  // Focuses the first tabbable element within the ancestor element.
  focusAncestor: function focusAncestor() {
    if (!_executionEnvironment.canUseDOM || !ancestor) {
      return;
    }
    var tabbableElements = (0, _tabbable["default"])(ancestor);
    var firstTabbable = tabbableElements[0];
    if (firstTabbable) {
      firstTabbable.focus();
    }
  },
  // Checks if the ancestor element or any of its descendants have focus.
  focusExists: function focusExists() {
    return _executionEnvironment.canUseDOM && (document.activeElement === ancestor || ancestor.contains(document.activeElement));
  },
  // Return focus to previously stored element.
  returnFocusToStoredElement: function returnFocusToStoredElement() {
    if (_executionEnvironment.canUseDOM) {
      try {
        focusLaterElement.focus();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("You tried to return focus to ".concat(focusLaterElement, " but it is not in the DOM anymore"));
      }
      focusLaterElement = null;
    }
  },
  // Sets up the focus to the ancestor element.
  setupScopedFocus: function setupScopedFocus(_ref) {
    var ancestorElement = _ref.ancestorElement;
    ancestor = ancestorElement;
    window.addEventListener('keydown', handleScopedKeyDown, false);
  },
  // Stores the active element.
  // Useful when an element's focus is removed and we want to return focus to it later.
  storeActiveElement: function storeActiveElement() {
    focusLaterElement = _executionEnvironment.canUseDOM ? document.activeElement : null;
  },
  // Removes focus management setup.
  teardownScopedFocus: function teardownScopedFocus() {
    ancestor = null;
    if (_executionEnvironment.canUseDOM) {
      window.removeEventListener('keydown', handleScopedKeyDown);
    }
  }
};
var _default = exports["default"] = ElementFocus;
//# sourceMappingURL=dom-element-focus.js.map